import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "v-application", attrs: { "data-qa": "doctor-cases" } },
    [
      _c(_setup.PreviewCasesSlider, {
        attrs: {
          "doctor-cases": _vm.doctorCases,
          "doctor-case-count": _vm.doctorCaseCount,
        },
        on: { "click-slide": _setup.handleClickSlide },
      }),
      _vm._v(" "),
      _c(
        _setup.CoreDrawer,
        {
          attrs: {
            "is-back": "",
            title: _vm.$t("Фото до и после", { ns: _vm.$i18next.language }),
            width: 650,
            "data-qa": _setup.isMobile
              ? "doctor-cases_dialog"
              : "doctor-cases_drawer",
          },
          on: { back: _setup.casesData.closeModal },
          model: {
            value: _setup.casesData.isVisibleModal,
            callback: function ($$v) {
              _vm.$set(_setup.casesData, "isVisibleModal", $$v)
            },
            expression: "casesData.isVisibleModal",
          },
        },
        [
          _c(_setup.CasesDetails, {
            ref: "casesDetailsRef",
            attrs: {
              doctor: _vm.doctor,
              "cases-deatils": _setup.casesData.doctorCases,
              "has-appointment-section": !!_setup.appointmentSection,
              "x-space-class": "px-4",
            },
            on: {
              "click-appointment": _setup.scrollToAppointment,
              "click-services-details": _setup.handleClickServicesDetails,
            },
          }),
          _vm._v(" "),
          _setup.casesData.hasNextPage
            ? _c(
                "div",
                { staticClass: "d-flex py-8 ma-auto" },
                [
                  _c(VProgressCircular, {
                    directives: [
                      {
                        def: Intersect,
                        name: "intersect",
                        rawName: "v-intersect",
                        value: _setup.handleIntersection,
                        expression: "handleIntersection",
                      },
                    ],
                    staticClass: "ma-auto",
                    attrs: {
                      "data-qa": _setup.isMobile
                        ? "doctor-cases_dialog_progress"
                        : "doctor-cases_drawer_progress",
                      size: "40",
                      width: "2.8",
                      color: "primary",
                      indeterminate: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        _setup.ServiceDetailsModal,
        {
          attrs: {
            "total-price": _setup.totalPrice,
            "is-doctor-work-at-lpu":
              _setup.caseServicesData.caseServicesData.is_doctor_work_at_lpu,
          },
          model: {
            value: _setup.caseServicesData.isVisibleModal,
            callback: function ($$v) {
              _vm.$set(_setup.caseServicesData, "isVisibleModal", $$v)
            },
            expression: "caseServicesData.isVisibleModal",
          },
        },
        [
          _c(
            VExpandTransition,
            [
              _setup.caseServicesData.isLoading
                ? _c(
                    "div",
                    { staticClass: "progress-circular" },
                    [
                      _c(VProgressCircular, {
                        staticClass: "ma-auto",
                        attrs: {
                          "data-qa":
                            "doctor-cases_service_details_modal_progress",
                          size: "32",
                          width: "2",
                          color: "primary",
                          indeterminate: "",
                        },
                      }),
                    ],
                    1
                  )
                : _c(_setup.ServiceDetailsContent, {
                    attrs: {
                      "services-data": _setup.caseServicesData.caseServicesData,
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "doctor-cases-alert-modal",
            size: "sm",
            title: _setup.alertDialogProps.title,
          },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "modal-actions-btn-close",
                        color: "primary",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _setup.alertDialogActive = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.alertDialogProps.confirmText) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.alertDialogActive,
            callback: function ($$v) {
              _setup.alertDialogActive = $$v
            },
            expression: "alertDialogActive",
          },
        },
        [
          _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.alertDialogProps.contentText) +
                "\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }